import React, { useRef } from 'react'
import styled from 'styled-components'
import { BiCategoryAlt } from "react-icons/bi";
import MyselfGrid from './MyselfGrid'
import { motion, useScroll, useTransform } from 'framer-motion';

const MyselfMain = () => {
  const container = useRef(null);

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start end', 'end start']
  })

  const y = useTransform(scrollYProgress, [0, 1], ['0%', '-30%'])

  return (
    <MyselfMainDiv>
      <motion.div ref={container}
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          ease: [0.65, 0, 0.35, 1],
          duration: 1,
          delay: 1
        }}
        className="MymainDiv">

        <MyMainIntro className="myMainIntro">
          <div className="arrow">
            <BiCategoryAlt />
          </div>
          <div className="introContent">
            <p> I sculpt engaging web experiences with a harmonious fusion of code and creativity.
              <em> I push my work to new horizons, always putting quality first </em>
            </p>
          </div>
        </MyMainIntro>

        <MyMainImg>
          <motion.div
            style={{ y }}
            className="myMainImg" />
        </MyMainImg>

      </motion.div>

      <MyselfGrid/>
    </MyselfMainDiv>
  )
}

export default MyselfMain

const MyMainImg = styled.div`
  flex: 0.5;
  overflow: hidden;

  @media only screen and (max-width: 1365px) {
    flex: 0.6 !important;
  }

  @media only screen and (max-width: 835px) {
    flex: none !important;
    height: 90vh;
  }

  @media only screen and (max-width: 680px) {
    height: 80vh !important;
  }

  @media only screen and (max-width: 540px) {
    height: 60vh !important;
  }

  .myMainImg{
    background: url('/My/me.jpg') no-repeat center center / cover;
    background-size: cover;
    height: 105%;
    position:relative;
    top: -5%;
  }
`

const MyMainIntro = styled.div`
  flex: 0.4;
  padding:1rem;
  @media only screen and (max-width: 835px) {
    flex: none !important;
  }

  display: flex;
  gap: 4rem;

  @media only screen and (max-width: 925px) {
    gap: 2rem !important;
  }

  @media only screen and (max-width: 835px) {
    flex-direction: column;
  }
  .arrow{
    svg {
      font-size: 2rem;
    }
  }

  .introContent{
    display: flex;
    flex-direction : column;
    p{
      font-size: 1.5rem;
      font-family: var(--font6);
      font-weight: 450;

      @media only screen and (max-width: 1365px) {
        font-size: 1.2rem !important;
        padding-top: 1rem;
      }
    }
    em{
      font-weight: 450;
      font-family: var(--font6);
      font-size: 1.5rem;
      @media only screen and (max-width: 1365px) {
        font-size: 1.2rem !important;
      }
    }
  }
`

const MyselfMainDiv = styled.div`
  width: 80%;
  min-height: 100vh;
  margin: auto;

  @media only screen and (max-width: 1365px) {
    width: 90% !important;
  }
  
  .MymainDiv{
    display: flex;
    min-height: 100vh;
    justify-content: space-between;
    overflow: hidden;

    @media only screen and (max-width: 1210px) {
      gap: 2rem;
    }

    @media only screen and (max-width: 835px) {
      flex-direction: column;
    }
  }
`